import * as React from 'react';
import Box from '@mui/material/Box';
import { Alert, Button, ButtonProps, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Tab, Tabs, TextField, Typography } from '@mui/material';
import Layout from '../components/Utilities/Layout';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import { Extraccion } from '../Data/Extraccion';
import EntitySettings from '../components/EntitySettings';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import { Cliente } from '../Clientes/Cliente';
import DataSearchForm, { SearchModel } from '../Data/DataSearchForm';
import Common from '../utilities/common';
import $ from "jquery";
import Man2OutlinedIcon from '@mui/icons-material/Man2Outlined';
import Woman2OutlinedIcon from '@mui/icons-material/Woman2Outlined';
import { DataGrid } from '@mui/x-data-grid';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';

export interface INewExtraccionState {
    selectedTab: string;
    selectedClient: any;
    clientes: Cliente[];
    extractData: Extraccion;
    data: any[];
    filteredData: any[];
    inFallowByClientData: any[];
    inFallowByVerticalData: any[];
    openExportDialog: boolean;
    openItemsExceededDialog: boolean;
}

export default class NewExtraccion extends React.Component<{}, INewExtraccionState> {
    _clienteId: number = -1;
    _searchModel: SearchModel[] = [];
    _rows: number = 0;
    _inFallowByClientData: number = 0;
    _inFallowByVerticalData: number = 0;
    RenderHeader: any;

    public constructor(props: {}) {
        super(props);

        this.state = {
            extractData: new Extraccion(),
            selectedTab: 'datos',
            selectedClient: null,
            clientes: [],
            data: [],
            filteredData: [],
            inFallowByClientData: [],
            inFallowByVerticalData: [],
            openExportDialog: false,
            openItemsExceededDialog: false
        }
    }

    componentDidMount(): void {
        this.GetClientes();
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.Extracciones} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Extracciones',
                            url: '/extracciones'
                        },
                        {
                            title: 'Nueva extracción',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <ExitToAppOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Nueva extracción
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='stepper' style={{marginTop: '20px'}}>
                        <Box>
                            <FormControl fullWidth variant="standard">
                                <InputLabel id="labelCliente">Cliente</InputLabel>
                                <Select label="Cliente" labelId='labelCliente' onChange={(event: SelectChangeEvent) => {
                                    this._clienteId = Number(event.target.value);
                                    this.GetClientData();
                                    this.GetInFallowByClient();
                                    this.GetInFallowByVertical();
                                }}>
                                    {
                                        this.state.clientes.map((value: Cliente, index: number) => {
                                            return (
                                                <MenuItem value={value.id}>
                                                    {
                                                        value.razonSocial
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            {
                                this.state.selectedClient != null && (
                                    <div className='extractClientData'>
                                        <Grid container spacing={2}>
                                            <Grid item xs={2}>
                                                <Typography variant='body2' fontWeight={500}>
                                                    Vertical:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Typography variant='body2'>
                                                {
                                                    this.state.selectedClient.vertical
                                                }
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography variant='body2' fontWeight={500}>
                                                    Barbecho por cliente:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Typography variant='body2'>
                                                {
                                                    !isNaN(this.state.selectedClient.clientDefaultFallow) && (
                                                        <Typography variant='body2'>
                                                        {
                                                            `${this.state.selectedClient.clientDefaultFallow} días`
                                                        }
                                                        </Typography>
                                                    )
                                                }
                                                {
                                                    isNaN(this.state.selectedClient.clientDefaultFallow) && (
                                                        <Typography variant='body2'>
                                                        No especificado
                                                        </Typography>
                                                    )
                                                }
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography variant='body2' fontWeight={500}>
                                                    Barbecho por vertical:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={10}>
                                                {
                                                    !isNaN(this.state.selectedClient.verticalDefaultFallow) && (
                                                        <Typography variant='body2'>
                                                        {
                                                            `${this.state.selectedClient.verticalDefaultFallow} días`
                                                        }
                                                        </Typography>
                                                    )
                                                }
                                                {
                                                    isNaN(this.state.selectedClient.verticalDefaultFallow) && (
                                                        <Typography variant='body2'>
                                                        No especificado
                                                        </Typography>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </div>
                                )
                            }
                        </Box>
                    </Box>
                    <React.Fragment>
                    {
                        this.state.selectedClient != null && (
                            <Box className="stepper" style={{marginTop: '20px'}}>
                                <Typography variant='h5' style={{marginBottom: '20px'}}>
                                    Búsqueda
                                </Typography>
                                <DataSearchForm clientId={this._clienteId} multiFields={true} onSearchEnd={(response: any[], searchModel: SearchModel[]) => {
                                    this._searchModel = searchModel;
                                    this._rows = response.length;
                                    const extractData = this.state.extractData;
                                    extractData.rows = response.length;
                                    this.GetInFallowByClient();
                                    this.GetInFallowByVertical();

                                    this.setState(
                                        {
                                            filteredData: response,
                                            extractData: extractData
                                        }
                                    );
                                }}/>
                            </Box>
                        )
                    }
                    {
                        this.state.selectedClient != null && (
                            <Box className="stepper" style={{marginTop: '20px'}}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={this.state.selectedTab} onChange={(event: React.SyntheticEvent, newValue: string) => {
                                        this.setState({
                                            selectedTab: newValue
                                        });
                                    }}>
                                        <Tab label={
                                            <Typography variant='body2'>
                                                <StorageOutlinedIcon className='tab_icon'/>
                                                {
                                                    `Datos (${this.state.filteredData.length})`
                                                }
                                            </Typography>
                                        } value={"datos"}/>
                                        {
                                            this.state.inFallowByClientData.length > 0 && (
                                                <Tab label={
                                                    <Typography variant='body2'>
                                                        <HandshakeOutlinedIcon className='tab_icon'/>
                                                        {
                                                            `Barbecho por cliente (${this.state.inFallowByClientData.length})`
                                                        }
                                                    </Typography>
                                                } value={"infallowbyclient"}/>
                                            )
                                        }
                                        {
                                            this.state.inFallowByVerticalData.length > 0 && (
                                                <Tab label={
                                                    <Typography variant='body2'>
                                                        <StorefrontOutlinedIcon className='tab_icon'/>
                                                        {
                                                            `Barbecho por vertical (${this.state.inFallowByVerticalData.length})`
                                                        }
                                                    </Typography>
                                                } value={"infallowbyvertical"}/>
                                            )
                                        }
                                    </Tabs>
                                </Box>
                                {
                                    this.state.selectedTab == 'datos' && (
                                        <DataGrid
                                            autoHeight
                                            rows={this.state.filteredData}
                                            loading={this.state.filteredData.length == 0}
                                            slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                            columns={[
                                                { 
                                                    field: 'nombre', 
                                                    headerName: 'Nombre', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'nombre')
                                                    )
                                                },
                                                { 
                                                    field: 'apellidos', 
                                                    headerName: 'Apellidos', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'apellidos')
                                                    )
                                                },
                                                { 
                                                    field: 'telefono', 
                                                    headerName: 'Telefono', 
                                                    width: 150,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'telefono')
                                                    )
                                                },
                                                { 
                                                    field: 'tipoVia', 
                                                    headerName: 'Tipo de vía', 
                                                    width: 150,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'tipoVia')
                                                    )
                                                },
                                                { 
                                                    field: 'nombreVia', 
                                                    headerName: 'Nombre de la vía', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'nombreVia')
                                                    )
                                                },
                                                { 
                                                    field: 'numeroVia', 
                                                    headerName: 'Número', 
                                                    width: 100,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'numeroVia')
                                                    )
                                                },
                                                { 
                                                    field: 'restoDireccion', 
                                                    headerName: 'Resto dirección', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'restoDireccion')
                                                    )
                                                },
                                                { 
                                                    field: 'cp', 
                                                    headerName: 'CP', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'cp')
                                                    )
                                                },
                                                { 
                                                    field: 'municipio', 
                                                    headerName: 'Municipio', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'municipio')
                                                    )
                                                },
                                                { 
                                                    field: 'provincia', 
                                                    headerName: 'Provincia', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'provincia')
                                                    )
                                                },
                                                { 
                                                    field: 'fechaNacimiento', 
                                                    headerName: 'Fecha de nacimiento', 
                                                    width: 200,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'fechaNacimiento')
                                                    )
                                                },
                                                { 
                                                    field: 'email', 
                                                    headerName: 'Email', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'email')
                                                    )
                                                },
                                                { 
                                                    field: 'sexo', 
                                                    headerName: 'Sexo', 
                                                    width: 100,
                                                    renderCell: ({ row }) => (
                                                        <div>
                                                            {
                                                                row.sexo?.toLowerCase() == 'h' && (
                                                                    <Man2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                                )
                                                            }
                                                            {
                                                                row.sexo?.toLowerCase() == 'm' && (
                                                                    <Woman2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                },
                                                { 
                                                    field: 'operador', 
                                                    headerName: 'Operador', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'operador')
                                                    )
                                                },
                                                { 
                                                    field: 'cupsLuz', 
                                                    headerName: 'Cups Luz', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'cupsLuz')
                                                    )
                                                },
                                                { 
                                                    field: 'cupsGas', 
                                                    headerName: 'Cups Gas', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'cupsGas')
                                                    )
                                                },
                                                { 
                                                    field: 'url', 
                                                    headerName: 'URL', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'url')
                                                    )
                                                },
                                                { 
                                                    field: 'ip', 
                                                    headerName: 'IP', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'ip')
                                                    )
                                                }
                                            ]}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: { page: 0, pageSize: 30 },
                                                },
                                            }}
                                            pageSizeOptions={[30, 60, 100, 250, 300]}
                                            hideFooter={this.state.filteredData.length <= 30}
                                        />
                                    )
                                }
                                {
                                    this.state.selectedTab == 'infallowbyclient' && (
                                        <DataGrid
                                            autoHeight
                                            rows={this.state.inFallowByClientData}
                                            loading={this.state.inFallowByClientData.length == 0}
                                            slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                            columns={[
                                                { 
                                                    field: 'extraccionId', 
                                                    headerName: 'Extraccion ID', 
                                                    width: 100,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'extraccionId')
                                                    )
                                                },
                                                { 
                                                    field: 'nombre', 
                                                    headerName: 'Nombre', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'nombre')
                                                    )
                                                },
                                                { 
                                                    field: 'apellidos', 
                                                    headerName: 'Apellidos', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'apellidos')
                                                    )
                                                },
                                                { 
                                                    field: 'telefono', 
                                                    headerName: 'Telefono', 
                                                    width: 150,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'telefono')
                                                    )
                                                },
                                                { 
                                                    field: 'tipoVia', 
                                                    headerName: 'Tipo de vía', 
                                                    width: 150,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'tipoVia')
                                                    )
                                                },
                                                { 
                                                    field: 'nombreVia', 
                                                    headerName: 'Nombre de la vía', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'nombreVia')
                                                    )
                                                },
                                                { 
                                                    field: 'numeroVia', 
                                                    headerName: 'Número', 
                                                    width: 100,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'numeroVia')
                                                    )
                                                },
                                                { 
                                                    field: 'restoDireccion', 
                                                    headerName: 'Resto dirección', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'restoDireccion')
                                                    )
                                                },
                                                { 
                                                    field: 'cp', 
                                                    headerName: 'CP', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'cp')
                                                    )
                                                },
                                                { 
                                                    field: 'municipio', 
                                                    headerName: 'Municipio', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'municipio')
                                                    )
                                                },
                                                { 
                                                    field: 'provincia', 
                                                    headerName: 'Provincia', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'provincia')
                                                    )
                                                },
                                                { 
                                                    field: 'fechaNacimiento', 
                                                    headerName: 'Fecha de nacimiento', 
                                                    width: 200,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'fechaNacimiento')
                                                    )
                                                },
                                                { 
                                                    field: 'email', 
                                                    headerName: 'Email', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'email')
                                                    )
                                                },
                                                { 
                                                    field: 'sexo', 
                                                    headerName: 'Sexo', 
                                                    width: 100,
                                                    renderCell: ({ row }) => (
                                                        <div>
                                                            {
                                                                row.sexo?.toLowerCase() == 'h' && (
                                                                    <Man2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                                )
                                                            }
                                                            {
                                                                row.sexo?.toLowerCase() == 'm' && (
                                                                    <Woman2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                },
                                                { 
                                                    field: 'cupsLuz', 
                                                    headerName: 'Cups Luz', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'cupsLuz')
                                                    )
                                                },
                                                { 
                                                    field: 'cupsGas', 
                                                    headerName: 'Cups Gas', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'cupsGas')
                                                    )
                                                },
                                                { 
                                                    field: 'url', 
                                                    headerName: 'URL', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'url')
                                                    )
                                                },
                                                { 
                                                    field: 'ip', 
                                                    headerName: 'IP', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'ip')
                                                    )
                                                }
                                            ]}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: { page: 0, pageSize: 30 },
                                                },
                                            }}
                                            pageSizeOptions={[30, 60, 100, 250, 300]}
                                            hideFooter={this.state.filteredData.length <= 30}
                                        />
                                    )
                                }
                                {
                                    this.state.selectedTab == 'infallowbyvertical' && (
                                        <DataGrid
                                            autoHeight
                                            rows={this.state.inFallowByVerticalData}
                                            loading={this.state.inFallowByVerticalData.length == 0}
                                            slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                            columns={[
                                                { 
                                                    field: 'extraccionId', 
                                                    headerName: 'Extraccion ID', 
                                                    width: 100,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'extraccionId')
                                                    )
                                                },
                                                { 
                                                    field: 'nombre', 
                                                    headerName: 'Nombre', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'nombre')
                                                    )
                                                },
                                                { 
                                                    field: 'apellidos', 
                                                    headerName: 'Apellidos', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'apellidos')
                                                    )
                                                },
                                                { 
                                                    field: 'telefono', 
                                                    headerName: 'Telefono', 
                                                    width: 150,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'telefono')
                                                    )
                                                },
                                                { 
                                                    field: 'tipoVia', 
                                                    headerName: 'Tipo de vía', 
                                                    width: 150,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'tipoVia')
                                                    )
                                                },
                                                { 
                                                    field: 'nombreVia', 
                                                    headerName: 'Nombre de la vía', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'nombreVia')
                                                    )
                                                },
                                                { 
                                                    field: 'numeroVia', 
                                                    headerName: 'Número', 
                                                    width: 100,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'numeroVia')
                                                    )
                                                },
                                                { 
                                                    field: 'restoDireccion', 
                                                    headerName: 'Resto dirección', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'restoDireccion')
                                                    )
                                                },
                                                { 
                                                    field: 'cp', 
                                                    headerName: 'CP', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'cp')
                                                    )
                                                },
                                                { 
                                                    field: 'municipio', 
                                                    headerName: 'Municipio', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'municipio')
                                                    )
                                                },
                                                { 
                                                    field: 'provincia', 
                                                    headerName: 'Provincia', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'provincia')
                                                    )
                                                },
                                                { 
                                                    field: 'fechaNacimiento', 
                                                    headerName: 'Fecha de nacimiento', 
                                                    width: 200,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'fechaNacimiento')
                                                    )
                                                },
                                                { 
                                                    field: 'email', 
                                                    headerName: 'Email', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'email')
                                                    )
                                                },
                                                { 
                                                    field: 'sexo', 
                                                    headerName: 'Sexo', 
                                                    width: 100,
                                                    renderCell: ({ row }) => (
                                                        <div>
                                                            {
                                                                row.sexo?.toLowerCase() == 'h' && (
                                                                    <Man2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                                )
                                                            }
                                                            {
                                                                row.sexo?.toLowerCase() == 'm' && (
                                                                    <Woman2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                },
                                                { 
                                                    field: 'cupsLuz', 
                                                    headerName: 'Cups Luz', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'cupsLuz')
                                                    )
                                                },
                                                { 
                                                    field: 'cupsGas', 
                                                    headerName: 'Cups Gas', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'cupsGas')
                                                    )
                                                },
                                                { 
                                                    field: 'url', 
                                                    headerName: 'URL', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'url')
                                                    )
                                                },
                                                { 
                                                    field: 'ip', 
                                                    headerName: 'IP', 
                                                    width: 250,
                                                    renderCell: ({ row }) => (
                                                        Common.RenderCell(row, 'ip')
                                                    )
                                                }
                                            ]}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: { page: 0, pageSize: 30 },
                                                },
                                            }}
                                            pageSizeOptions={[30, 60, 100, 250, 300]}
                                            hideFooter={this.state.filteredData.length <= 30}
                                        />
                                    )
                                }
                            </Box>
                        )
                    }
                    {
                        this.state.selectedClient != null && this.state.filteredData.length > 0 && (
                            <Box className='stepper' sx={{textAlign: 'right', marginTop: '20px'}}>
                                <Button variant="contained" onClick={() => {
                                    this.setState(
                                        {
                                            openExportDialog: true
                                        }
                                    )
                                }}>
                                    Extraer datos
                                </Button>
                            </Box>
                        )
                    }
                    </React.Fragment>
                    <Dialog open={this.state.openExportDialog} fullWidth>
                        <DialogTitle>
                            Exportación
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item xs={7}>
                                    <Typography variant='body2' fontWeight={500}>
                                        Registros a exportar
                                        <Typography variant='caption' component={'div'}>
                                            Indique el número de registros que desea extraer
                                        </Typography>
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <FormControl fullWidth>
                                        <TextField variant='standard' type='number' defaultValue={this.state.extractData.rows} value={this.state.extractData.rows} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            var max = this._rows + this._inFallowByClientData + this._inFallowByVerticalData;
                                            console.log('VALUE:', max);
                                            if(Number(event.currentTarget.value) > max) {
                                                this.setState({
                                                    openItemsExceededDialog: true
                                                });
                                            }
                                            else {
                                                const extractData = this.state.extractData;
                                                extractData.rows = Number(event.currentTarget.value);
                                                this.setState(
                                                    {
                                                        extractData: extractData
                                                    }
                                                )
                                            }
                                        }}/>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography variant='body2' fontWeight={500}>
                                        Barbecho (en días)
                                        <Typography variant='caption' component={'div'}>
                                            Establezca los días en que los registros deben permanecer en barbecho
                                        </Typography>
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <FormControl fullWidth>
                                        <TextField variant='standard' type='number' defaultValue={this.state.extractData.fallow} value={this.state.extractData.fallow} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            const extractData = this.state.extractData;
                                            extractData.fallow = Number(event.target.value);
                                            this.setState(
                                                {
                                                    extractData: extractData
                                                }
                                            )
                                        }}/>
                                    </FormControl>
                                </Grid>
                                {
                                    this.state.extractData.rows != null && (this.state.extractData.rows! < this.state.filteredData.length) && (
                                        <React.Fragment>
                                            <Grid item xs={7}>
                                                <Typography variant='body2' fontWeight={500}>
                                                    Selección de registros
                                                    <Typography variant='caption' component={'div'}>
                                                        Indique el modo de selección para extraer los registros
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={5}>
                                                <FormControl fullWidth>
                                                    <Select variant='standard' defaultValue='first' value={this.state.extractData.type} onChange={(event: SelectChangeEvent) => {
                                                        const extractData = this.state.extractData;
                                                        extractData.type = event.target.value;
                                                        this.setState(
                                                            {
                                                                extractData: extractData
                                                            }
                                                        )
                                                    }}>
                                                        <MenuItem value={'first'}>
                                                            {
                                                                `${this.state.extractData.rows} primeros registros`
                                                            }
                                                        </MenuItem>
                                                        <MenuItem value={'last'}>
                                                        {
                                                                `${this.state.extractData.rows} últimos registros`
                                                            }
                                                        </MenuItem>
                                                        <MenuItem value={'random'}>
                                                            Aleatorio
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </React.Fragment>
                                    )
                                }
                                {
                                    this.state.extractData.rows != null && (this.state.extractData.rows! > this.state.filteredData.length) && (
                                        <React.Fragment>
                                            <Grid item xs={12}>
                                                <Alert severity='info'>
                                                    Ha seleccionado más registros de los disponibles para la extracción, por lo que se utilizarán los registros en barbecho para completar el número de registros indicado
                                                </Alert>
                                            </Grid>
                                            <Grid item xs={7}>
                                                <Typography variant='body2' fontWeight={500}>
                                                    Prioridad del barbecho:
                                                    <Typography variant='caption' component={'div'}>
                                                        Indique la prioridad para extraer los datos del barbecho
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={5}>
                                                <FormControl fullWidth>
                                                    <Select variant='standard' defaultValue='vertical' value={this.state.extractData.fallowPriority} onChange={(event: SelectChangeEvent) => {
                                                        const extractData = this.state.extractData;
                                                        extractData.fallowPriority = event.target.value;
                                                        this.setState(
                                                            {
                                                                extractData: extractData
                                                            }
                                                        )
                                                    }}>
                                                        <MenuItem value={'vertical'}>
                                                            Primero barbecho vertical
                                                        </MenuItem>
                                                        <MenuItem value={'cliente'}>
                                                            Primero barbecho del cliente
                                                        </MenuItem>
                                                        <MenuItem value={'date'}>
                                                            Por fecha
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </React.Fragment>
                                    )
                                }
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.Save.bind(this)}>OK</Button>
                            <Button onClick={() => {
                                this.setState(
                                    {
                                        openExportDialog: false
                                    }
                                )
                            }}>Cancelar</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog open={this.state.openItemsExceededDialog} fullWidth>
                        <DialogTitle>
                            ¡Atención!
                        </DialogTitle>
                        <DialogContent>
                            El número de registros no puede ser mayor que los registros disponibles.
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => {
                                this._rows = this.state.filteredData.length;
                                const extractData = this.state.extractData;
                                extractData.rows = (this.state.filteredData.length + this.state.inFallowByClientData.length + this.state.inFallowByVerticalData.length);
                                this.setState(
                                    {
                                        extractData: extractData,
                                        openItemsExceededDialog: false
                                    }
                                )
                            }}>OK</Button>
                        </DialogActions>
                    </Dialog>
                </Layout>
            </SecurityTrimmer>
        )
    }

    private GetClientData() {
        let url = `${Common.END_POINT}/clientes/${this._clienteId}/getextractiondata`;
        $.ajax((
            {
                url: url,
                type: "GET",
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log('GetClientData', response);
            const extractData = this.state.extractData;
            extractData.clientId = this._clienteId;
            extractData.fallow = !isNaN(response[0].clientDefaultFallow) ? response[0].clientDefaultFallow : response[0].verticalDefaultFallow;

            this.setState(
                {
                    selectedClient: response[0]
                }
            );

            this.Get(extractData);
            this.GetInFallowByClient();
            this.GetInFallowByVertical();

        }).fail((jqXHR, textStatus, errorThrown) => {
            
        });
    }

    private Get(extractData: Extraccion): void {
        let url = `${Common.END_POINT}/extracciones/${this._clienteId}/search`;
        const searchModel: SearchModel[] = [];

        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(searchModel),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            extractData.rows = Number(response.length);
            this._rows = Number(response.length);

            this.setState(
                {
                    filteredData: response,
                    extractData: extractData
                }
            );
        })
    }

    private GetInFallowByClient(): void {
        let url = `${Common.END_POINT}/extracciones/${this._clienteId}/search/infallowbyclient`;

        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._searchModel),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log('GetInFallowByClient', response);
            this._inFallowByClientData = response.length;
            
            this.setState(
                {
                    inFallowByClientData: response
                }
            );
        })
    }

    private GetInFallowByVertical(): void {
        let url = `${Common.END_POINT}/extracciones/${this._clienteId}/search/infallowbyvertical`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._searchModel),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log('GetInFallowByVertical', response);
            this._inFallowByVerticalData = response.length;
            this.setState(
                {
                    inFallowByVerticalData: response
                }
            );
        })
    }

    private GetClientes(): void {
        let url = `${Common.END_POINT}/clientes`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: Cliente[]) => {
            this.setState(
                {
                    clientes: response
                }
            );
        });
    }

    private Save() {
        let url = `${Common.END_POINT}/extracciones/${this._clienteId}/${this.state.extractData.type}/${this.state.extractData.rows}/${this.state.extractData.fallow}/${this.state.extractData.fallowPriority}`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._searchModel),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            window.location.href = '/extracciones';
        }).fail((jqXHR, textStatus, errorThrown) => {
            
        });
    }
}
